import React, { useState, useEffect } from "react";
import Menu from "../Menu";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import SuccessMessage from "../../components/successMessage";
import FailedMessage from "../../components/FailedMessage";
import useApiUrls from "../../useApiUrls";

const UpdateMerchant = () => {
  const navigate = useNavigate();
  const { id } = useParams(); // Get the merchant ID from the URL
  const { getUrlByOperation, error: urlError } = useApiUrls();

  // State to hold form data
  const [formData, setFormData] = useState({
    id: id,
    posname: "",
    merchantid: "",
    key: "",
    remark: "",
    active: true,
  });

  // State to hold API response or error
  const [message, setMessage] = useState("");

  // Fetch the existing data for the merchant
  useEffect(() => {
    const fetchMerchantData = async () => {
      if (!id) return; // Exit if there is no ID

      const localStorageData = JSON.parse(localStorage.getItem("user"));
      // if (!localStorageData) {
      //   console.error("User not logged in, redirecting to login");
      //   navigate("/login");
      //   return;
      // }

      // const token = localStorageData.token;
      // const userid = localStorageData.userid;
      const token = getCookie("token");
      const userid = getCookie("userid");
  
    
  
      if (!token || !userid) {
        console.error("Missing token or userId in localStorage");
        return;
      }

      try {
        const posSearch = getUrlByOperation("posSearch");
        console.log("Search URL:", posSearch); // Debug the URL

        const response = await axios.post(
          posSearch,
          { id: id },
          {
            headers: {
              "X-Authorization": token,
              UserId: userid,
              "Content-Type": "application/json-patch+json",
            },
          }
        );

        if (
          response.data &&
          Array.isArray(response.data.data) &&
          response.data.data.length > 0
        ) {
          setFormData({
            ...response.data.data[0],
            active: response.data.data[0].active === "Active", // Convert to boolean
          });
        } else {
          // setMessage("Failed to fetch merchant data: Data format invalid.");
        }
      } catch (error) {
        console.error("Error fetching merchant data:", error);
        // setMessage("Failed to fetch merchant data.");
      }
    };

    fetchMerchantData();
  }, [id, getUrlByOperation, navigate]); // Ensure it only runs on initial load and not on every render

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "active" ? value === "Active" : value, // Convert active to boolean
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent the form from refreshing the page
    // const localStorageData = JSON.parse(localStorage.getItem("user"));
    // const token = localStorageData?.token;
    // const userid = localStorageData?.userid;
    const token = getCookie("token");
    const userid = getCookie("userid");

    if (!token || !userid) {
      console.error("Missing token or userId in localStorage");
      return;
    }

    const updateData = {
      id: formData.id,
      active: formData.active, // Ensure it's a boolean value
      posname: formData.posname,
      merchantid: formData.merchantid,
      key: formData.key,
      remark: formData.remark,
    };

    try {
      const posUpdate = getUrlByOperation("posUpdate");
      await axios.post(
        posUpdate,
        updateData,
        {
          headers: {
            "X-Authorization": token,
            UserId: userid,
            "Content-Type": "application/json-patch+json",
          },
        }
      );

      setMessage("Data updated successfully!");
      setTimeout(() => {
        navigate("/merchantList");
      }, 3000);
    } catch (error) {
      console.error("Failed to update data:", error);
      setMessage("Failed to update data.");
    }
  };

  return (
    <>
      <Menu />
      <div className="wrapper">
        <div className="content-wrapper">
          <section className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6"></div>
              </div>
            </div>
          </section>
          <section className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="card card-info">
                    <div className="card-header">
                      <h3 className="card-title">
                        {id ? "Update" : "Add"} Merchant
                      </h3>
                    </div>
                    <div className="card-body">
                      <form id="add-items" onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Pos Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.posname}
                                onChange={handleChange}
                                name="posname"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Merchant Name</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.merchantid}
                                onChange={handleChange}
                                name="merchantid"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Api Key</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.apikey}
                                onChange={handleChange}
                                name="key"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Remark</label>
                              <input
                                type="text"
                                className="form-control"
                                value={formData.remark}
                                onChange={handleChange}
                                name="remark"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-6">
                            <div className="form-group">
                              <label>Active</label>
                              <select
                                className="form-control"
                                name="active"
                                value={formData.active ? "Active" : "Deactive"}
                                onChange={handleChange}
                              >
                                <option value="Active">Active</option>
                                <option value="Deactive">Deactive</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div className="form-footer">
                          <button type="submit" className="btn btn-info">
                            {id ? "Update" : "Add"}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      {message && (
        message === "Data updated successfully!" ? (
          <SuccessMessage message={message} />
        ) : (
          <FailedMessage message={message} />
        )
      )}
    </>
  );
};

export default UpdateMerchant;
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
}
